import * as React from 'react';

import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const Icon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon icon-tabler icon-tabler-letter-b"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        strokeWidth="2"
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M7 20v-16h6a4 4 0 0 1 0 8a4 4 0 0 1 0 8h-6"></path>
        <line x1="7" y1="12" x2="13" y2="12"></line>
      </svg>
    </SvgIcon>
  );
};

export default Icon;
